import {useDebugValue} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import type {AppState} from '../state/store';

export default function useTypedSelector<R>(
  selector: (state: AppState) => R
): R {
  const result = useSelector(selector, shallowEqual);
  useDebugValue(result);
  return result;
}
